import * as Square from "@square/web-sdk";
import { useCallback, useMemo, useState } from "react";

import { SquareCard } from "../types";

export const useTokenizeCard = ({
  card,
  onComplete,
  onError,
}: {
  card: Square.Card | undefined;
  onComplete: (squareCard: SquareCard) => void | Promise<void>;
  onError?: () => void;
}) => {
  const [loading, setLoading] = useState(false);
  const handleTokenizeCard = useCallback(async () => {
    setLoading(true);
    if (!card) {
      setLoading(false);
      return;
    }
    const response = await card.tokenize();

    setLoading(false);
    if (response.details?.card && response.token) {
      const squareCard: SquareCard = {
        card: {
          brand: response?.details?.card.brand,
          expirationMonth: response.details.card.expMonth,
          expirationYear: response.details.card.expYear,
          lastFourDigits: response.details.card.last4,
          postalCode: response.details.billing?.postalCode ?? "",
          type: response.details.card.cardType ?? "",
          prepaidType: "",
        },
        nonce: response.token,
      };

      await onComplete(squareCard);
    } else {
      setLoading(false);
      onError?.();
    }
  }, [card, onComplete, onError]);

  return useMemo(
    () => [handleTokenizeCard, loading] as const,
    [handleTokenizeCard, loading]
  );
};
